import { createApi } from "@reduxjs/toolkit/query/react";
import baseQuery from "./baseQuery";
import { API_SERVER } from "../utils/urlBack_End";

export const portalMultisociedadApi = createApi({
  reducerPath: "portalMultisociedadApi",
  baseQuery: baseQuery(`${API_SERVER}/portalMultisociedad`),
  tagTypes: ["SociedadesPortal", "FacturasPortal"],
  endpoints: (builder) => ({
    obtenerSociedadesPortal: builder.query({
      query: () => "/sociedades",
      providesTags: ["SociedadesPortal"],
    }),
    obtenerFacturasPortal: builder.query({
      query: (params) => ({ url: "/facturas", params }),
      providesTags: ["FacturasPortal"],
    }),
  }),
});

export const {
  useObtenerSociedadesPortalQuery,
  useObtenerFacturasPortalQuery,
} = portalMultisociedadApi;
